export const Colors = {
  primaryColor: "#9298ac",
  secondaryColor: "#97d7d8",
  black: "#000",
  white: "#fff",
  gary: "#e4e9f2",
};
